module.exports = __webpack_public_path__ + "static/media/hide-chart.bf0012b5.svg";